<template>
  <div class="download-all-container">
    <!-- ... existing code ... -->
    <span
      class="download-all-button"
      @click="handleDownloadAllFilesButtonClicked"
    >
      {{ $t("imageNavigation.downloadAll") }}
    </span>

    <!-- Download Progress Dialog -->
    <el-dialog
      v-model="showDownloadAllDialog"
      center
      @close="handleBulkDownloadModalClosed"
    >
      <el-progress
        class="zip-file-progress"
        type="circle"
        :percentage="zipFileLoadingPercentage"
        :format="percentageFormatter"
      ></el-progress>
      <div class="zip-file-generation-message">
        <p class="loading-text">Loading...</p>
        <p class="progress-text">
          {{ $t("imageNavigation.downloadProgressText") }}
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useDownloadAllDialog } from "@/composables/useDownloadAllDialog";
import API from "@/api/API";

const props = defineProps(["categoryId"]);

const { showDownloadAllDialog } = useDownloadAllDialog();

const zipFileLoadingPercentage = ref(0);
const checkBulkDownloadTimeout = ref(null);

const checkBulkDownloadStatus = async (categoryPk) => {
  try {
    await API.projectFileCategories.checkBulkDownload(categoryPk);
    // If successful, download is ready
    const res = await API.projectFileCategories.getZipFileUrl(categoryPk);
    window.location.href = res.data.url;
    showDownloadAllDialog.value = false;
    clearTimeout(checkBulkDownloadTimeout.value);
  } catch (error) {
    if (error.response?.data?.progress != null) {
      showDownloadAllDialog.value = true;
      zipFileLoadingPercentage.value = Number(
        error.response.data.progress.toFixed(2)
      );
      // Schedule next check in 3 seconds
      checkBulkDownloadTimeout.value = setTimeout(() => {
        checkBulkDownloadStatus(categoryPk);
      }, 3000);
    } else {
      showDownloadAllDialog.value = false;
      clearTimeout(checkBulkDownloadTimeout.value);
    }
  }
};

const handleDownloadAllFilesButtonClicked = async () => {
  zipFileLoadingPercentage.value = 0;

  try {
    // Start checking bulk download status
    await checkBulkDownloadStatus(props.categoryId);
  } catch (error) {
    console.error("Download error:", error);
    showDownloadAllDialog.value = false;
  }
};

const handleBulkDownloadModalClosed = () => {
  if (checkBulkDownloadTimeout.value) {
    clearTimeout(checkBulkDownloadTimeout.value);
  }
};
</script>

<style lang="scss" scoped>
.download-all-container {
  display: flex;
  padding: 16px;
  .download-all-button {
    color: #23e7a5;
    padding: 10px 0px 0px 0px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    display: inline-block;
    border-bottom: 2px solid #23e7a5;
    // text-align: left;
  }

  :deep(.el-dialog--center .el-dialog__body) {
    text-align: center;
    color: #fff;
  }
  :deep(.el-progress__text) {
    color: white;
  }
  :deep(.el-dialog) {
    background-color: #27292c;
    border-radius: 10px;
    height: 490px;
    padding: 80px;
  }
  :deep(.el-progress-circle__track) {
    stroke: #646464;
  }
  :deep(.el-progress-circle__path) {
    stroke: #23e7a5 !important;
  }
  :deep(.el-dialog__close) {
    color: white;
    font-size: 30px;
    width: 30px;
    height: 30px;
  }
}
:deep(.el-dialog__headerbtn) {
  margin: 16px;
}

.zip-file-generation-message {
  .loading-text {
    margin-top: 2rem;
  }
  .progress-text {
    margin-top: 4rem;
  }
}
</style>
